module.exports = __webpack_public_path__ + "img/990RecMacEN1.39b782d9.png";